import { render, staticRenderFns } from "./ProductRow.vue?vue&type=template&id=3ca0c692&scoped=true"
import script from "./ProductRow.vue?vue&type=script&lang=ts"
export * from "./ProductRow.vue?vue&type=script&lang=ts"
import style0 from "./ProductRow.vue?vue&type=style&index=0&id=3ca0c692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca0c692",
  null
  
)

export default component.exports